import {
    getProvidersRouteLoading,
    getProvidersRouteReject,
    getProvidersRouteRequest,
    getProvidersRouteSuccess
} from "../../actions/providersRoutes/getAll";
import { PageSize } from "../../../../config/const";

export const getProvidersRoute = (formData) => async (dispatch, getState) => {
    dispatch(getProvidersRouteLoading());
    try {
        const { data } = await getProvidersRouteRequest(formData, getState);
        dispatch(getProvidersRouteSuccess(data))
    } catch (error) {
        dispatch(getProvidersRouteReject(error))
    }
    return Promise.resolve();
};